import { Endpoints } from "../../contants/endpoints";
import { api } from "../../lib/api";

export async function getListBrand() {
  try {
    const res = await api.get(Endpoints?.bard?.getList);
    if (res.data) {
      return res.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("API brand list error:", error);
    return [];
  }
}
